module.exports = __webpack_public_path__ + "img/shipin3.136f721f.png";